module.exports = __webpack_public_path__ + "static/media/dont2.154210da.png";